
<template>
  <!--审核详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <div style="width:200px;height:200px">
            <img :src="avatarUrl" alt="" class="avatar" @click="openImgModel(avatarUrl)">
          </div>
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="12">
              <a-form-item class="value-indent" :label="item.label">
                <div v-if="item.key==='avatar'">
                  <img :src="item.value" alt="" class="avatar" @click="openImgModel(item.value)">
                </div>
                <span v-else class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>资质材料</h3>
      </div>
      <div class="card-body">
        <div class="box">
          <span>身份证正面:</span>
          <img :src="idCard" alt="" class="id-card" @click="openImgModel(idCard)">
        </div>
      </div>
    </div>
    <template v-if="isCheck">
      <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>
    </template>

    <!--查看图片的弹窗-->
    <a-modal
      class="img-modal"
      :visible="showPic"
      @cancel="showPic=false"
      width="auto"
      v-bind="$store.state.modalDetailConfig"
    >
      <div class="img-box">
        <img :src="showImg" alt="" class="model-img">
      </div>
    </a-modal>
    <!--拒绝的弹窗-->
    <a-modal
      title="拒绝原因"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="form">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="拒绝原因">
          <a-textarea v-decorator="['check_remark', decoratorOptions.check_remark]" placeholder="请输入拒绝原因"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'anchorReviewDetail',
  data () {
    return {
      showPic: false,
      showImg: '',
      isCheck: false,
      visible: false,
      idCard: '',
      avatarUrl: '',
      btnLoading: { loading: false },
      toolBarList: [
        {text: '通过', handle: (item) => this.passApply('1'), type: 'primary', loading: true, key: 'pass', disabled: false},
        {text: '拒绝', handle: (item) => this.openModal(), type: 'danger', key: 'reject', disabled: false}
      ],
      decoratorOptions: {
        check_remark: {
          rules: [
            { required: true, message: '请输入拒绝原因' },
            { min: 2, max: 20, message: '拒绝原因为2-20个字' }
          ]
        }
      },
      baseInfo: [
        // {key: 'avatar', label: '头像', value: ''},
        {key: 'nick_name', label: '昵称', value: ''},
        {key: 'mobile', label: '手机号', value: ''},
        {key: 'true_name', label: '姓名', value: ''},
        {key: 'user_type_desc', label: '用户类型', value: ''},
        {key: 'idcard', label: '身份证号', value: ''},
        {key: 'create_time', label: '提交时间', value: ''}
      ]
      // decoratorOptions: {
      //   check_remark: {
      //     rules: [
      //       { required: true, message: '请输入驳回原因' },
      //       { min: 2, max: 20, message: '驳回原因为2-20个字符' }
      //     ]
      //   }
      // }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  created () {
    let url = '';
    if (this.$route.query.title === '审核详情') {
      url = `/live/applys/${this.$route.query.id}`;
    } else if (this.$route.query.title === '主播资料') {
      url = `/live/anchors/${this.$route.query.id}`;
    }
    this.getDetail(this.$route.query.id, url);
  },
  mounted () {
  },
  methods: {
    /* 打开弹窗 */
    openModal () {
      this.visible = true;
    },
    /* 获取详情 */
    getDetail (id, url) {
      this._get({
        url,
        params: {}
      }).then(({data}) => {
        this.idCard = data.idcard_image;
        if (data.check_status === 0) {
          this.isCheck = true;
        } else {
          this.isCheck = false;
        }
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
        this.avatarUrl = data.avatar;
        this.tableData = data.items;
      });
    },
    openImgModel (url) {
      this.showPic = true;
      this.showImg = url;
    },
    /* 点击确定弹窗 */
    confirm () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.handleSubmit('2', values);
      });
    },
    /* 点击通过申请 */
    passApply (type) {
      this.$confirm({
        title: '确定通过申请？',
        centered: true,
        onOk: () => {
          this.handleSubmit(type);
        }
      });
    },
    handleSubmit  (type, values) {
      this.$post({
        url: '/live/applys',
        params: {
          apply_id: this.$route.query.id,
          check_remark: values ? values.check_remark : '',
          check_status: type
        },
        btnLoading: this.btnLoading
      }).then((res) => {
        this.$store.commit('setOptData', true);
        this.visible = false;
        this.$message[type === '1' ? 'success' : 'error'](type === '1' ? '审核通过' : '审核已拒绝');
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.card-body{
  display: flex;
}
.box{
  display: flex;
  .id-card{
    width: 400px;
    height: 200px;
    margin-left: 10px;
    margin-top: -10px;
    cursor: pointer;
  }
}
.avatar{
  width: 150px;
  height:150px;
  border-radius: 50%;
  cursor: pointer;
}
.img-box{
  width: 100%;
  height: 600px;
  .model-img{
    height: 100%;
  }
}
</style>
